module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/transfer/transfer-recorders/transfer-recorders-form/transfer-recorders-form.component.css
// module id = ./src/app/hrms/transfer/transfer-recorders/transfer-recorders-form/transfer-recorders-form.component.css
// module chunks = main